import { type FullInterventionDefinitionViewModel } from '@generated';
import { DialogTrigger, Pressable } from 'react-aria-components';
import { Popover } from '~/shared/components/Popover';
import { Info } from 'lucide-react';
import { useWorkflowTranslations } from '~/features/workflowing/workflows/useWorkflowTranslations';

export function InterventionDefinitionInfo({
	interventionDefinition,
	interventionStatus
}: {
	interventionDefinition: FullInterventionDefinitionViewModel;
	interventionStatus?: string;
}) {
	const { getTitle } = useWorkflowTranslations();
	return (
		<>
			<div className="flex items-center gap-2">
				<label htmlFor={interventionDefinition.procedureConceptId} className="block font-medium text-gray-900">
					{interventionDefinition.title}
				</label>
				{interventionDefinition.documentationWorkflows.length > 0 && (
					<DialogTrigger>
						<Pressable>
							<Info role="button" className="size-5 cursor-pointer text-gray-500" />
						</Pressable>

						<Popover showArrow className="max-w-xs p-4">
							<span>
								Visit Types:&nbsp;
								{interventionDefinition.documentationWorkflows.map(x => getTitle(x.substring(0, x.lastIndexOf('.')))).join(', ')}
							</span>
						</Popover>
					</DialogTrigger>
				)}
				{interventionStatus && (
					<span className="rounded-full bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-700">{interventionStatus}</span>
				)}
			</div>
			<p className="mt-1 text-sm text-gray-600">{interventionDefinition.definitionText}</p>
		</>
	);
}
